"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferPreviewContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _Loader = require("../../components/Loader");
var _OfferPreview = require("../../components/OfferPreview");
var _hooks = require("../../hooks");
var _utils = require("../../utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const OfferPreviewContainer = _ref => {
  let {
    offerId,
    onClick,
    onOfferPhoneShow,
    onOfferFetchError,
    objectType
  } = _ref;
  const {
    loading,
    data
  } = (0, _hooks.useOfferFetch)({
    offerId,
    onError: onOfferFetchError
  });
  const handlePreviewClick = React.useCallback(() => {
    if (onClick) {
      onClick(offerId);
    }
  }, [offerId, onClick]);
  if (!loading && !data) {
    return null;
  }
  if (data && !loading) {
    return /*#__PURE__*/React.createElement(_OfferPreview.OfferPreview, (0, _extends2.default)({}, data, {
      name: (0, _utils.makeName)(objectType),
      onPhoneShow: onOfferPhoneShow,
      link: (0, _utils.makeOfferLink)(offerId),
      onClick: handlePreviewClick
    }));
  }
  return /*#__PURE__*/React.createElement(_Loader.Loader, null);
};
exports.OfferPreviewContainer = OfferPreviewContainer;